import React, { useEffect } from "react";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { selectCurrentForm } from "redux/helpers/helpers.selector";
import { NavigationContainer } from "./navigation.styles";
import NavigationButton from "components/navigation-button/navigation-button.component";
import { useAppSelector } from "utils/hooks";
import analyticsAPI from "utils/analyticsAPI";
import { buttonsCollection, gosButtonsCollection } from "utils/form-constants";
import { useNavigationHandler } from "./useNavigationHandler";

interface Props {
  isContextual: boolean;
  isGosForm?: boolean;
}

const Navigation: React.FC<Props> = ({ isContextual, isGosForm }) => {
  const currentForm = useAppSelector(selectCurrentForm);
  const appInsights = useAppInsightsContext();
  const pageEngagementStartTime = Date.now();
  const lastForm = currentForm;

  const { handleNextForm, isFormDisabled } = useNavigationHandler(isGosForm);

  const gosFormNames: Record<number, string> = {
    0: "DonorInfo",
    1: "InstitutionInfo",
    3: "Securities",
  };
  const defaultFormNames: Record<number, string> = {
    0: "DonationType",
    1: "DonorInfo",
    2: "Payment",
  };
  const componentName = (isGosForm ? gosFormNames : defaultFormNames)[lastForm];

  useEffect(() => {
    analyticsAPI.handleTrackPageView(appInsights, {
      name: componentName,
      pageEngagementStartTime,
    });
    return () => {
      const engagementTimeSeconds =
        (Date.now() - pageEngagementStartTime) / 1000;
      const metricData = {
        average: Math.round(engagementTimeSeconds * 100) / 100,
        name: "React Component Engaged Time (seconds)",
        sampleCount: 1,
      };
      const additionalProperties = { "Component Name": componentName };
      appInsights.trackMetric(metricData, additionalProperties);
    };
  }, [currentForm]); // eslint-disable-line

  return (
    <NavigationContainer
      role="navigation"
      isContextual={isContextual}
      data-cy="navigation"
      id="navigation"
    >
      {(isGosForm ? gosButtonsCollection : buttonsCollection).map(
        (button, index) => (
          <NavigationButton
            key={index}
            buttonText={button.buttonText}
            Icon={button.Icon}
            isActive={currentForm >= index}
            disabled={isFormDisabled}
            onClick={(e) => handleNextForm(e, index, button.buttonText)}
          />
        ),
      )}
    </NavigationContainer>
  );
};

export default Navigation;
